import { DownloadIcon } from '@primer/octicons-react';
import { Box } from '@primer/react';
import { useContext, useEffect } from 'react';
import Button from '../../components/ui/button';
import { ILayoutContext, LayoutContext } from '../../layout/Layout';
import Block from './Block';
import ChartSiSoTheoKhoi from './ChartSiSoTheoKhoi';
import ChartSiSoTheoTrangThai from './ChartSiSoTheoTrangThai';
import ThongKeCRMByChienDich from './ThongKeCRMByChienDich';
import ThongKeCRMByNguonBietToi from './ThongKeCRMByNguonBietToi';
import ThongKeCSKH from './ThongKeCSKH';
import ThongKeSiSoDataTable from './ThongKeSiSoDataTable';
import ThongKeCSKHByMonth from './ThongKeCSKHByMonth';

const ThongKePage = () => {
    const { setHideSubNav } = useContext<ILayoutContext>(LayoutContext);
    useEffect(() => {
        if (setHideSubNav) {
            setHideSubNav(true);
        }
        return () => {
            if (setHideSubNav) {
                setHideSubNav(false);
            }
        };
    }, [])
    return (
        <Box sx={{ backgroundColor: "#EFF2F4", minHeight: `${window.innerHeight - 90}px`, p: 3 }}>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                gap: 5
            }}>
                <Box>
                    <Box sx={{ fontWeight: "600", fontSize: 16, color: "fg.muted", mb: 2 }}>
                        Thống kê sĩ số
                    </Box>
                    <Box sx={{
                        display: "grid",
                        gap: 2,
                        gridTemplateColumns: "1fr 2fr"
                    }}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <Block>
                                <ChartSiSoTheoKhoi />
                            </Block>
                            <Block>
                                <ChartSiSoTheoTrangThai />
                            </Block>
                        </Box>
                        <Block>
                            <Box sx={{ display: "flex" }}>
                                <Box sx={{ flex: 1, fontSize: 24, fontWeight: 600 }}>Dữ liệu sĩ số học sinh chi tiết</Box>
                                <Box>
                                    <Button text='Tải xuống' leadingVisual={DownloadIcon} variant='invisible' />
                                </Box>
                            </Box>
                            <Box sx={{ fontSize: "1rem", color: "fg.muted" }}>Sĩ số cụ thể theo từng Trường, Khối, Hệ và các trạng thái</Box>
                            <ThongKeSiSoDataTable />
                        </Block>
                    </Box>
                </Box>
                <Box>
                    <Box sx={{ fontWeight: "600", fontSize: 16, color: "fg.muted", mb: 2 }}>
                        Thống kê tuyển sinh
                    </Box>
                    <Box sx={{
                        display: "grid",
                        gap: 2,
                        gridTemplateColumns: "2fr 1fr"
                    }}>
                        <Block>
                            <ThongKeCRMByChienDich />
                        </Block>
                        <Block>
                            <ThongKeCRMByNguonBietToi />
                        </Block>
                    </Box>
                </Box>
                <Box>
                    <Box sx={{ fontWeight: "600", fontSize: 16, color: "fg.muted", mb: 2 }}>
                        Thống kê chăm sóc khách hàng
                    </Box>
                    <Box sx={{
                        display: "grid",
                        gap: 2,
                        gridTemplateColumns: "1fr 2fr"
                    }}>
                        <Block>
                            <ThongKeCSKH />
                        </Block>
                        <Block>
                            <ThongKeCSKHByMonth />
                        </Block>
                    </Box>

                </Box>

            </Box>

        </Box>
    );
};

export default ThongKePage;